export const worklistDataCopy = [
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'Z12567K',
    MRN: 10001,
    dateOfService: '11/25/2023',
    revenueCode: '',
    cptHcpcs: '99213 - 25',
    currentFinancialClass: 'Medicare',
    insurance: 'NGS Medicare',
    cobOrder: 'Primary',
    billedAmount: 450,
    outstandingAmount: 450,
    denialCategory: 'Coding (CO-4)',
    followUpDate: '11/21/2024',
    assignedTo: 'Austin Langer',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'Z12367N',
    MRN: 10002,
    dateOfService: '12/09/2023',
    revenueCode: '',
    cptHcpcs: '78451',
    currentFinancialClass: 'Medicare MCO',
    insurance: 'Health First',
    cobOrder: 'Primary',
    billedAmount: 1579,
    outstandingAmount: 1579,
    denialCategory: 'Auth (CO-197)',
    followUpDate: '11/21/2024',
    assignedTo: 'Austin Langer',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'Z35367K',
    MRN: 10003,
    dateOfService: '06/09/2024',
    revenueCode: '',
    cptHcpcs: '36415',
    currentFinancialClass: 'Medicare Supp Plan',
    insurance: 'AARP',
    cobOrder: 'Secondary',
    billedAmount: 1295,
    outstandingAmount: 325,
    denialCategory: 'Coverage (PR-26)',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'B12567T',
    MRN: 10004,
    dateOfService: '09/05/2024',
    revenueCode: '',
    cptHcpcs: '70551',
    currentFinancialClass: 'Auto PIP',
    insurance: 'Geico',
    cobOrder: 'Primary',
    billedAmount: 2200,
    outstandingAmount: 2200,
    denialCategory: 'No Response',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'N12567D',
    MRN: 10005,
    dateOfService: '07/15/2023',
    revenueCode: '',
    cptHcpcs: '93015',
    currentFinancialClass: 'Medicaid HMO',
    insurance: 'Fidelis',
    cobOrder: 'Primary',
    billedAmount: 325,
    outstandingAmount: 325,
    denialCategory: 'COB (CO-22)',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Albany Medical center',
    typeOfBill: 'CMS 1500',
    placeOfService: 'Outpatient Hospital',
    claimId837: 'L13562K',
    MRN: 10006,
    dateOfService: '08/15/2022',
    revenueCode: '',
    cptHcpcs: '64640',
    currentFinancialClass: 'Commercial',
    insurance: 'UHC',
    cobOrder: 'Secondary',
    billedAmount: 2578,
    outstandingAmount: 975,
    denialCategory: 'Others (OA-23)',
    followUpDate: '11/25/2024',
    assignedTo: 'Sylvia Menon',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'N12362N',
    MRN: 10007,
    dateOfService: '11/25/2023',
    revenueCode: '',
    cptHcpcs: '76856',
    currentFinancialClass: 'Medicare',
    insurance: 'NGS Medicare',
    cobOrder: 'Primary',
    billedAmount: 450,
    outstandingAmount: 450,
    denialCategory: 'Coding (CO-4)',
    followUpDate: '11/21/2024',
    assignedTo: 'Austin Langer',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'Z25365D',
    MRN: 10008,
    dateOfService: '12/09/2023',
    revenueCode: '',
    cptHcpcs: '73221',
    currentFinancialClass: 'Medicare MCO',
    insurance: 'Health First',
    cobOrder: 'Primary',
    billedAmount: 1579,
    outstandingAmount: 1579,
    denialCategory: 'Auth (CO-197)',
    followUpDate: '11/21/2024',
    assignedTo: 'Austin Langer',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'P65367T',
    MRN: 10009,
    dateOfService: '06/09/2024',
    revenueCode: '',
    cptHcpcs: '78815',
    currentFinancialClass: 'Medicare Supp Plan',
    insurance: 'AARP',
    cobOrder: 'Secondary',
    billedAmount: 1295,
    outstandingAmount: 325,
    denialCategory: 'Coverage (PR-26)',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'D12497T',
    MRN: 10010,
    dateOfService: '09/05/2024',
    revenueCode: '',
    cptHcpcs: '20610',
    currentFinancialClass: 'Auto PIP',
    insurance: 'Geico',
    cobOrder: 'Primary',
    billedAmount: 2200,
    outstandingAmount: 2200,
    denialCategory: 'No Response',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'N12160L',
    MRN: 100011,
    dateOfService: '07/15/2023',
    revenueCode: '',
    cptHcpcs: 'J7352',
    currentFinancialClass: 'Medicaid HMO',
    insurance: 'Fidelis',
    cobOrder: 'Primary',
    billedAmount: 325,
    outstandingAmount: 325,
    denialCategory: 'COB (CO-22)',
    followUpDate: '11/25/2024',
    assignedTo: 'Jay Hicks',
    assignedOn: '11/21/2024',
    comments: ''
  },
  {
    attachments: '',
    facilityLocation: 'Saratoga Hospital',
    typeOfBill: 'CMS 1500',
    placeOfService: 'ASC',
    claimId837: 'L13555O',
    MRN: 10012,
    dateOfService: '08/15/2022',
    revenueCode: '',
    cptHcpcs: '93306',
    currentFinancialClass: 'Commercial',
    insurance: 'UHC',
    cobOrder: 'Secondary',
    billedAmount: 2578,
    outstandingAmount: 975,
    denialCategory: 'Others (OA-23)',
    followUpDate: '11/25/2024',
    assignedTo: 'Sylvia Menon',
    assignedOn: '11/21/2024',
    comments: ''
  }
];

export const agingDataCopy = [
  {
    agingBucket: 'Number Of Claims',
    days1: '15000',
    days2: '10112',
    days3: '20096',
    days4: '7946',
    days5: '25792',
    days6: '5489',
    days7: '35489'
  },
  {
    agingBucket: 'Outstanding Amount',
    days1: '$69,000,075.31',
    days2: '$75,032,075.00',
    days3: '$30,032,075.00',
    days4: '$10,032,075.00',
    days5: '$75,032,075.00',
    days6: '$52,132,122.00',
    days7: '$122,132,122.00'
  },
  {
    agingBucket: 'Outstanding/Claim',
    days1: '$4,600.01',
    days2: '$7,420.10',
    days3: '$1,494.43',
    days4: '$1,262.53',
    days5: '$2,909.12',
    days6: '$9,497.56',
    days7: '$3,441.41'
  },
  {
    agingBucket: 'Weightage (%)',
    days1: '16%',
    days2: '17%',
    days3: '7%',
    days4: '2%',
    days5: '17%',
    days6: '12%',
    days7: '28%'
  }
];

export const claimLevelDataCopy = [
  {
    id: 1,
    dos: '09/24/2024',
    revenueCode: '0615',
    cptHCPCS: '72141',
    modifier: '',
    units: '1',
    icd10: 'M54.2',
    currentFinancialClass: 'Medicare Supp Plan',
    insurance: 'AARP',
    billed: '$548.00',
    outstanding: '$80.00'
  }
];

export const billingFinancialData = [
  {
    action: 'Appended Modifier 25',
    datetime: '09/26/2024 07:36 A.M',
    username: 'Austin Langer'
  },
  {
    action: 'Billed to primary Medicare (837 Claim ID : XX6745892A)',
    datetime: '10/02/2024 08:46 A.M',
    username: 'John Doe'
  },
  {
    action: 'Claim edit "Patient cannot be identified"',
    datetime: '10/03/2024',
    username: ''
  },
  {
    action: 'Cleared edit and billed to primary Medicare',
    datetime: '10/03/2024 04:00 P.M',
    username: 'Jennifer Adams'
  },
  {
    action: 'Accepted by primary Medicare',
    datetime: '10/04/2024',
    username: ''
  },
  {
    action: 'Primary payment - $320.00 - Auto post ERA 2345TR97528',
    datetime: '10/10/2024 04:00 P.M',
    username: 'Jacob Adams'
  },
  {
    action:
      'Contractual adjustment (CO 45) - $148.00 - Auto post ERA 2345TR97528',
    datetime: '10/10/2024 04:00 P.M',
    username: 'Jacob Adams'
  },
  {
    action:
      'Crossover to secondary AARP (MA 18) - $80.00 - Auto post ERA 2345TR97528',
    datetime: '10/10/2024 04:00 P.M',
    username: 'Jacob Adams'
  }
];
